import { DriverEdit } from "./DriverEdit";
import { DriversList } from "./DriversList";
import { DriverCreate } from "./DriverCreate";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";

export default {
  icon: AssignmentIndOutlinedIcon,
  list: DriversList,
  create: DriverCreate,
  edit: DriverEdit,
};
